// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CaseOut } from './caseOut.zod.ts';

export const CasesOut = zod.object({
  "cases": zod.array(CaseOut)
});

export type CasesOut = zod.input<typeof CasesOut>;
export type CasesOutOutput = zod.output<typeof CasesOut>;
